import {createSelector} from 'reselect';

const gsConfigSelector = (state) => (state && state.gsConfig) || {};

const featureFlagsSelector = createSelector(gsConfigSelector, (gsConfig) => gsConfig.features || {});

const showGoogleResellerDisclaimerSelector = createSelector(
  featureFlagsSelector,
  (features = {}) => !!features['common.googleResellerDisclaimer.show']
);

export {showGoogleResellerDisclaimerSelector};
